<template>
  <div>
    <div
      class="modal animated fadeIn"
      tabindex="-1"
      id="usersLoaderModal"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-sm" style="top: 40%">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-fluid">
              <div class="row">
                <div class="col-md-12">
                  <center>
                    <img src="static/assets/images/ajax-loader.gif" /> deleting,
                    please wait..
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">Manage users</div>
            <fieldset class="border p-3">
              <legend class="auto-wp"></legend>
              <div></div>
              <div>
                <div class="usersLoader">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i
                    class="fa fa-spinner fa-spin"
                    style="font-size: 24px; color: blue"
                  ></i>
                  loading users...
                </div>
                <vue-good-table
                  :columns="columns"
                  :rows="systemUsers"
                  :fixed-header="true"
                  :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 6,
                    position: 'bottom',
                    perPageDropdown: [3, 7, 9],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'Account_status'">
                      {{
                        props.row.Account_status === 0
                          ? "Pending"
                          : props.row.Account_status === 1
                          ? "Active"
                          : props.row.Account_status === 2
                          ? "Disabled"
                          : props.row.Account_status === 3
                          ? "inActive"
                          : ""
                      }}
                    </span>
                    <span v-else>{{
                      props.formattedRow[props.column.field]
                    }}</span>

                    <span v-if="props.column.field == 'Action'">
                      <button
                        class="btn btn-primary btn-sm"
                        @click="userRoles(props.row.id)"
                      >
                        <i class="nav-icon i-Key-3 font-weight-bold"></i>
                      </button>

                      <button
                        class="btn btn-raised btn-raised-info btn-sm m-1"
                        @click="viewUser(props.row.id)"
                      >
                        <i class="nav-icon i-Pen-2 font-weight-bold"></i>
                      </button>

                      <button
                        class="btn btn-raised btn-raised-danger btn-sm m-1"
                        @click="deleteUser(props.row.id)"
                      >
                        <i class="nav-icon i-Close-Window font-weight-bold"></i>
                      </button>
                    </span>
                  </template>
                </vue-good-table>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      columns: [
        {
          label: " Fullnames",
          field: "fullname",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Email",
          field: "email",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: " Profilename",
          field: "profilename",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: " Gender",
          field: "gender",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Account status",
          field: "Account_status",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Action",
          field: "Action",
          width: "160px",
          html: true,
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
      ],
    };
  },
  created() {
    this.loadUsers();
  },
  computed: {
    ...mapGetters(["systemUsers"]),
  },
  methods: {
    ...mapActions(["loadUsers", "viewUser", "deleteUser", "userRoles"]),
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/users/manageusers.vue